import EventDispatcher from "../framework/EventDispatcher";
import ProviderService from "../services/ProviderService";

// Action Types
export  const GET_PROVIDER_CF = 'GET_PROVIDER_CF';

// Reducer
export default function reducer(state = {status: {}, form: {}}, action = {}) {
	switch (action.type) {
		
		case EventDispatcher.successAction(GET_PROVIDER_CF):
			const {customFields} = action.data;
			return {
				...state,
				customFields
			};
			break;
		default:
		return state;
	
	}
}


export function getProviderCF() {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_PROVIDER_CF);
		ProviderService.getProviderCF()
			.then(response => {
				const {actionStatus} = response;
				if (!actionStatus || actionStatus.status === "FAIL") {
					EventDispatcher.error(dispatch, GET_PROVIDER_CF, actionStatus);
				} else {
					const {provider} = response;
					EventDispatcher.success(dispatch, GET_PROVIDER_CF, {
						customFields: provider.customFields && provider.customFields || [],
					});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, GET_PROVIDER_CF, error);
			});
	}
}





// WEBPACK FOOTER //
// ./src/opencell/actions/ProviderActions.js